import React from "react";
import {
  FaFileContract,
  FaShieldAlt,
  FaPercent,
  FaUserShield,
  FaCubes,
  FaCoins,
  FaLink,
  FaVoteYea,
} from "react-icons/fa";

function FeaturesLending() {
  const features = [
    {
      title: "Smart Contract-Driven",
      desc: "Robust frameworks audited to ensure transparency, security, and traceability within autonomous networks.",
      icon: <FaFileContract />,
    },
    {
      title: "Collateralized Loans",
      desc: "Allow users to borrow assets by providing collateral, governed autonomously by algorithmic models.",
      icon: <FaShieldAlt />,
    },
    {
      title: "Custom Interest Rates",
      desc: "Offer dynamic or stable interest rates precisely tailored to market conditions and liquidity needs.",
      icon: <FaPercent />,
    },
    {
      title: "Non-Custodial",
      desc: "Users retain complete control over their assets without risking private-key interceptions globally.",
      icon: <FaUserShield />,
    },
    {
      title: "Multi-Asset Support",
      desc: "Enable lending and borrowing across a wide range of tokens, providing maximum choice and flexibility.",
      icon: <FaCubes />,
    },
    {
      title: "Yield for Lenders",
      desc: "Lenders consistently accumulate native tokens securing immense passive fiscal value stably.",
      icon: <FaCoins />,
    },
    {
      title: "Cross-Chain Sync",
      desc: "Facilitate asset movement across different blockchain networks, enhancing liquidity and outreach.",
      icon: <FaLink />,
    },
    {
      title: "Governance Module",
      desc: "Empower participants to actively democratize platform decision processes scaling accountability.",
      icon: <FaVoteYea />,
    },
  ];

  return (
    <div
      className="services-area pt-100 pb-100"
      style={{ background: "#f8fbff" }}
    >
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-lg-8 offset-lg-2">
            <h4 className="sub-title text-primary fw-bold mb-2">
              Platform Capabilities
            </h4>
            <h2 className="title fw-bold" style={{ fontSize: "42px" }}>
              Stunning Features of Our Platform
            </h2>
            <p className="mt-3 text-muted">
              We build production-ready decentralized protocols with elite
              features for the most demanding liquidity providers.
            </p>
          </div>
        </div>

        <div className="row g-4">
          {features.map((feature, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div
                className="card border-0 h-100 p-5 text-center"
                style={{
                  borderRadius: "24px",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
                  transition:
                    "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                  border: "1px solid #f0f0f0",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.boxShadow =
                    "0 20px 40px rgba(33, 150, 243, 0.1)";
                  e.currentTarget.style.borderColor = "rgba(33, 150, 243, 0.2)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(0,0,0,0.03)";
                  e.currentTarget.style.borderColor = "#f0f0f0";
                }}
              >
                <div
                  className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                  style={{
                    width: "70px",
                    height: "70px",
                    fontSize: "28px",
                    backgroundColor: "#f0f7ff",
                    // color: "#2196f3",
                    borderRadius: "20px",
                    transform: "rotate(-5deg)",
                  }}
                >
                  {feature.icon}
                </div>

                <h5 className="fw-extrabold mb-3" style={{ fontSize: "18px" }}>
                  {feature.title}
                </h5>

                <p
                  style={{
                    fontSize: "14px",
                    color: "#6c757d",
                    lineHeight: "1.7",
                    marginBottom: 0,
                  }}
                >
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FeaturesLending;
